import React from 'react';
import { LayoutDashboard, Users, FileText, LucideIcon, BriefcaseBusiness } from 'lucide-react';
import styles from './TabNavigation.module.scss';

interface Tab {
  id: 'identity' | 'anteproyectos' | 'dashboard' | 'curated-postulations';
  label: string;
  Icon: LucideIcon;
  badge?: number;
}

interface TabNavigationProps {
  activeTab: 'identity' | 'anteproyectos' | 'dashboard' | 'curated-postulations';
  onTabChange: (tab: 'identity' | 'anteproyectos' | 'dashboard' | 'curated-postulations') => void;
  identityCount?: number;
  projectsCount?: number;
  curatedCount?: number;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  identityCount = 0,
  projectsCount = 0,
  curatedCount = 0,
}) => {
  const tabs: Tab[] = [
    {
      id: 'dashboard',
      label: 'Panel de Control',
      Icon: LayoutDashboard
    },
    {
      id: 'identity',
      label: 'Validación de Identidad',
      Icon: Users,
      badge: identityCount
    },
    {
      id: 'anteproyectos',
      label: 'Ante Proyectos',
      Icon: FileText,
      badge: projectsCount
    },
    {
      id: 'curated-postulations',
      label: 'Postulaciones Externas',
      Icon: BriefcaseBusiness,
      badge: curatedCount
    }
  ];

  return (
    <div className={styles.tabNavigation}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <tab.Icon size={18} className={styles.icon} />
          <span className={styles.label}>{tab.label}</span>
          {tab.badge !== undefined && tab.badge > 0 && (
            <span className={styles.badge}>{tab.badge}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;

